import { toast } from 'sonner';

// Lightweight XP toast helper. Used from anywhere a user earns XP
// (game completion, lesson completion, journal entry, etc.)
// reason examples: 'lesson', 'journal', 'game:thought_defense'
export function notifyXp(result, reasonLabel) {
  if (!result || !result.xp_gained) return;
  const { xp_gained, bonus_xp, leveled_up, new_level, streak } = result;
  const lines = [];
  if (reasonLabel) lines.push(reasonLabel);
  if (bonus_xp && bonus_xp > 0) lines.push(`+${bonus_xp} streak bonus`);
  if (streak) lines.push(`${streak}-day streak`);

  toast.success(`+${xp_gained} XP`, {
    description: lines.filter(Boolean).join(' \u00B7 '),
    duration: 3500,
    style: {
      background: '#0B0B0C',
      color: '#F0C660',
      border: '1px solid rgba(212,164,55,0.4)',
    },
  });

  if (leveled_up) {
    setTimeout(() => {
      toast(`Level Up! You're now Level ${new_level}.`, {
        duration: 5000,
        style: {
          background: '#D4A437',
          color: '#0B0B0C',
          border: '1px solid #0B0B0C',
          fontWeight: 700,
          letterSpacing: '0.04em',
          textTransform: 'uppercase',
        },
      });
    }, 600);
  }
}
